module.exports = __webpack_public_path__ + "6477e7231623168e7e04abe3b73322ab.MP3";